import React from 'react';
import './App.css';
import Schedule from './Schedule';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Schedule />
      </header>
    </div>
  );
}

export default App;

